import queryString from 'query-string';
import { get, del, post } from './apiUtils';

const defaultUrl = '/RawMatPhrases/';

export default {
  getRawMatPhrases: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
  deleteRawMatPhrase: id => del(`${defaultUrl}${id}`),
  saveRawMatPhrase: data => post(`${defaultUrl}`, data),
};
